module.exports = __webpack_public_path__ + "static/feature-email-reports-383198f0c0874c4c07d5731a3aa79881.png";